<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <!-- 应用列表202408 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="12">
            <a-form-item label="应用名称">
              <a-input v-model="query.appName" placeholder="请输入应用名称" allow-clear />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <!-- <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del
                >删除</a-button> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :data-source="list" :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <template slot="statusAction" slot-scope="text,record">
        <a-switch :checked="(text == 1) ? true : false" @change="statusChange(record)" />
      </template>

      <span slot="sourceAction" slot-scope="text">
        <a-tag color="#C3C1E9" v-if="text == 1">默认数据</a-tag>
        <a-tag color="rgb(66, 211, 9)" v-else>新增模块</a-tag>
      </span>


      <span slot="action" slot-scope="text, record" v-if="record.source == 2">
        <a @click="edit(record)" v-action:edit>编辑</a>
        <a @click="deleteSelectRow(record)" v-action:del style="margin-left: 8px;color: red;">删除</a>

      </span>
    </a-table>
    <a-modal title="操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">

      <a-form class="log-form" :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="访问地址">
          <a-input placeholder="访问地址"
            v-decorator="['accessUrl', { rules: [{ required: true, message: '请输入访问地址' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用名称">
          <a-input placeholder="应用名称"
            v-decorator="['appName', { rules: [{ required: true, message: '请输入应用名称' }, { max: 9, message: '长度不能超过9个字符' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用类型">
          <a-input placeholder="应用类型" v-decorator="['appType', { rules: [{ message: '请输入应用类型' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应用编码">
          <a-input placeholder="应用编码"
            v-decorator="['appCode', { rules: [{ required: true, message: '请输入应用编码' }, { validator: checkData, trigger: 'blur' }] }]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="logo地址">
          <a-input placeholder="logo地址" v-decorator="['logoUrl']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否显示">
          <!-- <a-select placeholder="请选择"
            v-decorator="['status', { initialValue: 1 }, { rules: [{ required: true, message: '请选择状态' }] }]">
            <a-select-option :value="1">上线</a-select-option>
            <a-select-option :value="2">下线</a-select-option>
          </a-select> 
        , rules: [{ required: true, message: '请输入选择是否显示' }] -->
          <a-switch v-decorator="['status', { valuePropName: 'checked' }]" />

        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
          <a-input-number :formatter="limitNumber" :parser="limitNumber" :min="1"
            v-decorator="['sort', { rules: [{ type: 'number', pattern: '/[^\d]/g', required: true, message: '请输入数字' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
          <a-input placeholder="备注" v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'

const columns = [
  {
    title: '排序',
    dataIndex: 'sort'
  },
  {
    title: '是否显示',
    dataIndex: 'status',
    scopedSlots: { customRender: 'statusAction' }
  },
  {
    title: '应用名称',
    dataIndex: 'appName'
  },
  {
    title: '应用编码',
    dataIndex: 'appCode'
  },


  {
    title: '应用类型',
    dataIndex: 'appType'
  },
  {
    title: '数据来源',
    dataIndex: 'source',
    scopedSlots: { customRender: 'sourceAction' }
  },
  {
    title: '访问地址',
    dataIndex: 'accessUrl'
  },
  {
    title: 'logo地址',
    dataIndex: 'logoUrl'
  },

  {
    title: '备注',
    dataIndex: 'remark'
  },

  {
    title: '操作',
    dataIndex: 'action',
    width: 150,
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'LogList',
  data () {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      currentId: '',
      queryUrl: '/manager/users/tenant/pages',
      deleteUrl: '/manager/users/tenant/delete/',
      addOrUpdateUrl: '/manager/users/tenant/save/sys',
      query: {
        appName: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      selectedRows: []
    }
  },

  created () { },
  methods: {
    // 重置
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }
      this.selectedRows = []

      this.queryList()
    },
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query
      }

      params.page = this.pagination.current

      params.limit = this.pagination.pageSize


      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    deleteSelectRow (row) {
      this.selectedRows = [row.id]
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除${row.appName}吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http.get(_this.deleteUrl + row.id).then((res) => {
            if (res.code === 0) {
              _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
              _this.selectedRows = []
              _this.resetList()
              _this.queryList()
            }
          })
            .catch(() => { })
        },
        onCancel () {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        }
      })
    },
    // 正则不能输入中文
    checkData (rule, value, callback) {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('应用编码只能输入英文或数字、特殊符号!'))
        } else {
          callback()
        }
      }
      callback()
    },

    handleOk (e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        if (values.status == true) {
          values.status = '1'
        } else if (values.status == false) {
          values.status = '2'
        }
        if (!err) {
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, this.query.sysType ? {
            id: this.currentId,
            sysType: this.query.sysType,
            ...values
          } : {
            id: this.currentId,
            ...values
          })
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => { })
        }
      })
    },
    statusChange (e) {
      if (e.status == '2') {
        e.status = '1'
      } else {
        e.status = '2'
      }
      this.$http.put(this.addOrUpdateUrl, e).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.message)
          this.resetList()
        } else {
          this.$message.error('修改失败')
        }
      })
    },
    detailInfo (record) {
      this.detailForm = { ...record }
    },
    edit (record) {
      record.status = record.status == 1 ? true : false
      this.isUpdate = true
      this.currentId = record.id
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.addOrUpdateForm.setFieldsValue(record)
      })
    },
    // handleOk() {

    // },
    handleCancel () { }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
